import { date, notEmpty } from "@crehana/utils";
import { TCustomFieldTypeEnum, TSegmentationDataTypeEnum } from "./types.js";
const alphabeticSegmentationType = [
    TSegmentationDataTypeEnum.Country,
    TSegmentationDataTypeEnum.Gender,
    TSegmentationDataTypeEnum.Headquarter,
    TSegmentationDataTypeEnum.Position,
    TSegmentationDataTypeEnum.PositionCategory
];
const getFormType = (values)=>{
    if (!values) return;
    if (values.dataType !== TSegmentationDataTypeEnum.CustomField) return;
    return values.formType;
};
const getCategory = (values)=>{
    if (!values) return 'alphabetic';
    const dataType = values.dataType;
    if (dataType === TSegmentationDataTypeEnum.CustomField && values.formType) {
        const stringFormType = values.formType.toString();
        if (stringFormType === TCustomFieldTypeEnum.Date.toString()) return 'date';
        if (stringFormType === TCustomFieldTypeEnum.Number.toString()) return 'numeric';
        return 'alphabetic';
    }
    if (dataType && alphabeticSegmentationType.includes(dataType)) return 'alphabetic';
    if (dataType === TSegmentationDataTypeEnum.CompanyEntry) return 'date';
    return 'alphabetic';
};
function sanitizeInputValues(input) {
    return (Array.isArray(input) ? input : [
        input
    ]).filter(notEmpty);
}
function formatDateRange(from, to) {
    const fromFormatted = from ? date.format(from, 'DD-MM-YYYY') : void 0;
    const toFormatted = to && to !== from ? date.format(to, 'DD-MM-YYYY') : void 0;
    return [
        fromFormatted,
        toFormatted
    ].filter(notEmpty);
}
function mapStateToSegmentationCondition(state, fieldLabel) {
    if (!state.fieldId || 'date' !== state.category && !state.conditionalType) return {
        isValid: false
    };
    const baseData = {
        fieldId: state.fieldId,
        fieldLabel,
        dataType: state.availableFields.find((f)=>f.value === state.fieldId)?.dataType || TSegmentationDataTypeEnum.CustomField
    };
    if ([
        'alphabetic',
        'numeric'
    ].includes(state.category)) {
        const sanitizedInputValue = sanitizeInputValues(state.value?.input);
        const sanitizedSelectedValues = state.value?.selected || [];
        const conditionalValues = state.isTagSelect ? sanitizedSelectedValues : sanitizedInputValue;
        const data = {
            ...baseData,
            formType: 'numeric' === state.category ? TCustomFieldTypeEnum.Number : state.isTagSelect ? TCustomFieldTypeEnum.Multiple : TCustomFieldTypeEnum.Text,
            values: [
                {
                    operator: state.conditionalType,
                    value: 'alphabetic' === state.category ? conditionalValues : sanitizedInputValue
                }
            ]
        };
        return {
            data,
            isValid: !data?.values.some((v)=>0 === v.value.length)
        };
    }
    if ('date' === state.category && state.value?.date) {
        const { from, to } = state.value.date.dates;
        const data = {
            ...baseData,
            formType: TCustomFieldTypeEnum.Date,
            values: [
                {
                    value: formatDateRange(from, to)
                }
            ]
        };
        const isValid = 'range' === state.value.date.tab ? data?.values[0].value.length === 2 : data?.values[0].value.length === 1;
        return {
            data,
            isValid
        };
    }
    return {
        isValid: false
    };
}
export { formatDateRange, getCategory, getFormType, mapStateToSegmentationCondition, sanitizeInputValues };
